import React from "react";

import { Icon, IconSizeEnum, IconTypeEnum } from "@components/common/icon";

import "./styles.scss";
import { NewsLetterProps } from "./types";

const NewsLetter = ({ onChange, checked }: NewsLetterProps) =>
  (
    <div className="newsletter">
      <div className="newsletter__agreement">
        <input
          type="checkbox"
          checked={checked}
          onChange={() =>
            onChange((state: boolean) =>
              !state)}
        />
        <span>
          Даю
          {" "}
          <a href="/rassylka-agree" target="_blank" rel="noreferrer">
            согласие
          </a>
          {" "}
          на получение информационных и рекламных рассылок в соответствии с
          {" "}
          <a href="/privacy-policy" target="_blank" rel="noreferrer">
            политикой конфиденциальности
          </a>
        </span>
      </div>
      <ul>
        <li>
          <Icon size={IconSizeEnum.Size24} type={IconTypeEnum.Fire} />
          <b>Промокоды</b>
          {" "}
          для подписчиков
        </li>
        <li>
          <Icon size={IconSizeEnum.Size24} type={IconTypeEnum.Fire} />
          <b>Таро-прогнозы</b>
          {" "}
          на неделю
        </li>
        <li>
          <Icon size={IconSizeEnum.Size24} type={IconTypeEnum.Fire} />
          <b>Рекомендации экспертов</b>
          {" "}
          под ваш запрос
        </li>
      </ul>
    </div>
  );

export default NewsLetter;
